import { setAlert } from "./AlertAction";
import { commonAxios } from "../Global/CommonAxios";


export const fetchRebrandData = () => (dispatch, getState) => {
    commonAxios("fetch-wl-rebranding", {}, dispatch, getState().auth.token)
        .then(res => {
            if (res.status) {
                dispatch(setAlert(res.msg, 'success'));
                dispatch({ type: 'ADD_REBRAND', payload: res.data });

            }
        }).catch(error => {
            console.log(error)
        })
}


export const addRebrandData = (data, setLoader, setIsClicked) => (dispatch, getState) => {
    commonAxios("wl-rebranding", data, dispatch, getState().auth.token)
        .then(res => {
            if (res.status) {
                dispatch(setAlert(res.msg, 'success'));
                dispatch(fetchRebrandData());
                setIsClicked(true);

            } else {
                dispatch(setAlert(res.msg, 'danger'));
            }
            setLoader(false);
        }).catch(error => {
            console.log(error)
            setLoader(false);
        })
}

export const onDeleteRebrand = (deleteData, setLoader, Swal) => (dispatch, getState) => {
    commonAxios("delete-wl", deleteData, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                dispatch(removeRebrandData())
                dispatch(setAlert(res.msg, "success"))
            } else {
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader(false)
            Swal.close()
        }).catch((err) => {
            dispatch(setAlert(err.msg, "danger"))
            console.log(err)
        })
}

export const removeRebrandData = () => (dispatch) => {
    dispatch({ type: 'REMOVE_ADD_REBRAND' });
}